import { useContext } from 'react';

import { AppContext } from 'context/App';
import { useTranslation } from 'react-i18next';

import {
  FormError,
  ResetPasswordForm,
  ResetPasswordFormSubmitHandler,
} from 'components/Forms/ResetPasswordForm';

type RegisterProps = {
  sessionId: string;
  email: string;
};

export function Register({ sessionId, email }: RegisterProps) {
  const { t: translate } = useTranslation('resetPassword');
  const context = useContext(AppContext);

  const onSubmit: ResetPasswordFormSubmitHandler = async (data) => {
    const { password } = data;

    try {
      if (context && context.authentication.register) {
        await context.authentication.register({
          email,
          sessionId,
          password,
        });

        return;
      }
      throw Error(translate('error'));
    } catch (e) {
      const { message } = e as Error;

      if (message?.includes('429')) {
        throw new FormError('root', translate('tooManyRequests'));
      } else {
        throw new FormError('root', translate('error'));
      }
    }
  };

  return (
    <ResetPasswordForm
      onSubmit={onSubmit}
      submitText={translate('createPassword')}
    />
  );
}
